/**
 * @file        src/lib/toast.js
 * @description Imperative toast store. Renders via <ToastHost />.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
import { create } from 'zustand';

let nextId = 1;

export const useToasts = create((set, get) => ({
  items: [],
  push(item) {
    const id = nextId++;
    const entry = { id, type: 'info', ttl: 2800, ...item };
    set({ items: [...get().items, entry] });
    setTimeout(() => get().dismiss(id), entry.ttl);
  },
  dismiss(id) { set({ items: get().items.filter((t) => t.id !== id) }); },
}));

export const toast = {
  ok:   (title, msg) => useToasts.getState().push({ title, msg, type: 'ok' }),
  err:  (title, msg) => useToasts.getState().push({ title, msg, type: 'err' }),
  info: (title, msg) => useToasts.getState().push({ title, msg, type: 'info' }),
};
